import { ApolloError, type GraphQLErrors } from '@apollo/client/errors';

export function getErrors(error: ApolloError | GraphQLErrors | null | undefined): readonly Error[] {
  return error instanceof ApolloError ? (error.graphQLErrors.length ? error.graphQLErrors : [error]) : (error ?? []);
}
